import { useEffect } from "react";

// Lightweight SEO manager: title, meta description, canonical + optional JSON-LD
export function useSeo({ title, description, canonicalPath, jsonLd, image }) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (name, content, attr = "name") => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    const url = canonicalPath ? window.location.origin + canonicalPath : window.location.href;
    const ogImage = image ? (image.startsWith("http") ? image : window.location.origin + image) : window.location.origin + "/img/og-edilstudio.png";

    setMeta("description", description);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:url", url, "property");
    setMeta("og:image", ogImage, "property");
    setMeta("og:locale", "it_IT", "property");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    setMeta("twitter:image", ogImage);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonicalPath) {
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }
      canonical.setAttribute("href", window.location.origin + canonicalPath);
    }

    let script = document.getElementById("edil-jsonld");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.id = "edil-jsonld";
        script.type = "application/ld+json";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    }
    return () => {
      const s = document.getElementById("edil-jsonld");
      if (s) s.remove();
    };
  }, [title, description, canonicalPath, jsonLd, image]);
}
